'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SOCIAL_ICON_BORDER_RADIUS_TYPES = exports.SOCIAL_ICON_TYPES = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _SvgSocialIcon = require('./SvgSocialIcon.less');

var _SvgSocialIcon2 = _interopRequireDefault(_SvgSocialIcon);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_DIMENSION = 10;
var DIMENSION_BORDER_RATIO = 1 / 30;
var OUTLINE_SCALE = 10;

var SOCIAL_ICON_TYPES = exports.SOCIAL_ICON_TYPES = {
    BRANDED: 'branded',
    GRAYSCALE: 'grayscale',
    GRAYEDOUT: 'grayedout'
};

var SOCIAL_ICON_BORDER_RADIUS_TYPES = exports.SOCIAL_ICON_BORDER_RADIUS_TYPES = {
    CIRCLE: 'circle',
    NO_RADIUS: 'no_radius'
};

var DATA_HOOKS = {
    BG_FILL: 'bgFill',
    TEXT_FILL: 'textFill',
    CIRCLE_BORDER: 'circleBorder',
    SQUARE_BORDER: 'squareBorder'
};

var SvgSocialIcon = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(SvgSocialIcon, _React$Component);

    function SvgSocialIcon(props) {
        (0, _classCallCheck3.default)(this, SvgSocialIcon);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SvgSocialIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgSocialIcon)).call(this, props));

        _this._getRing = function (dimension) {
            var dim = OUTLINE_SCALE * dimension;
            var strokeWidth = Math.max(DIMENSION_BORDER_RATIO * dimension, 1);

            return _this._getOutline(dimension, _react2.default.createElement('circle', { cx: dim / 2,
                cy: dim / 2,
                r: (dim - OUTLINE_SCALE * strokeWidth) / 2,
                strokeWidth: OUTLINE_SCALE * strokeWidth,
                'data-hook': DATA_HOOKS.CIRCLE_BORDER,
                className: _SvgSocialIcon2.default.circleBorder }));
        };

        _this._getSquareOutline = function (dimension) {
            var dim = OUTLINE_SCALE * dimension;
            var strokeWidth = Math.max(DIMENSION_BORDER_RATIO * dimension, 1);

            return _this._getOutline(dimension, _react2.default.createElement('rect', { x: OUTLINE_SCALE * strokeWidth / 2,
                y: OUTLINE_SCALE * strokeWidth / 2,
                width: dim - OUTLINE_SCALE * strokeWidth,
                height: dim - OUTLINE_SCALE * strokeWidth,
                'data-hook': DATA_HOOKS.SQUARE_BORDER,
                className: _SvgSocialIcon2.default.squareBorder,
                strokeWidth: OUTLINE_SCALE * strokeWidth }));
        };

        _this._getOutline = function (dimension, elem) {
            var dim = OUTLINE_SCALE * dimension;
            return _react2.default.createElement(
                'svg',
                { width: dimension,
                    height: dimension,
                    viewBox: '0 0 ' + dim + ' ' + dim },
                elem
            );
        };

        _this._getTheme = function () {
            var theme = _lodash2.default.assign({}, _this.defaultTheme, _lodash2.default.isObject(_this.props.theme) && _this.props.theme || {});
            theme.inverse = theme.inverse || theme.backgroundColor === 6;
            theme.hasBackground = theme.hasBackground || theme.backgroundColor >= 0 && theme.backgroundColor < 6;
            return theme;
        };

        _this._getClassName = function (theme) {
            var _this$props = _this.props,
                type = _this$props.type,
                className = _this$props.className,
                hoverState = _this$props.hoverState;


            return [_SvgSocialIcon2.default.wrapper, _SvgSocialIcon2.default[type], _SvgSocialIcon2.default[theme.type], className, theme.hasBorder || theme.borderColor ? _SvgSocialIcon2.default.border : '', theme.borderRadius ? _SvgSocialIcon2.default[theme.borderRadius] : '', theme.inverse ? _SvgSocialIcon2.default.inverse : '', theme.hasBackground ? '' : _SvgSocialIcon2.default.noBackground, !!hoverState ? _SvgSocialIcon2.default.withHover : '', theme.backgroundColor ? '' + _SvgSocialIcon2.default['backgroundColor-' + theme.backgroundColor] : '', theme.iconColor ? '' + _SvgSocialIcon2.default['iconColor-' + theme.iconColor] : '', theme.borderColor ? '' + _SvgSocialIcon2.default['borderColor-' + theme.borderColor] : ''].join(' ');
        };

        _this._getIcon = function (dimension) {
            var icon = null;
            var attrs = _this._getIconAttrs();

            switch (_this.props.type) {
                case 'facebook':
                    icon = _this._getFacebookIcon(attrs);
                    break;
                case 'twitter':
                    icon = _this._getTwitterIcon(attrs);
                    break;
                case 'yelp':
                    icon = _this._getYelpIcon(attrs);
                    break;
                case 'foursquare':
                    icon = _this._getFourSquareIcon(attrs);
                    break;
                case 'instagram':
                    icon = _this._getInstagramIcon(attrs);
                    break;
                case 'tripadvisor':
                    icon = _this._getTripAdvisorIcon(attrs);
                    break;
            }

            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('rect', { width: '100%', height: '100%', 'data-hook': DATA_HOOKS.BG_FILL, className: _SvgSocialIcon2.default.bgFill }),
                _react2.default.createElement(
                    'svg',
                    { width: dimension, height: dimension, x: '0', y: '0', viewBox: '0 0 65 65' },
                    icon
                )
            );
        };

        _this._getIconAttrs = function () {
            return { style: _SvgSocialIcon2.default.textFill, dataHook: DATA_HOOKS.TEXT_FILL };
        };

        _this._getFacebookIcon = function (_ref) {
            var dataHook = _ref.dataHook,
                style = _ref.style;

            return _react2.default.createElement(
                'g',
                { 'data-hook': dataHook },
                _react2.default.createElement('path', { transform: 'translate(-1, -1)', className: style, d: 'M35.5,50.6V34.9h5.3l.8-6.1H35.5V24.9c0-1.8.5-3,3-3h3.2V16.4a43.3,43.3,0,0,0-4.7-.2c-4.7,0-7.9,2.9-7.9,8.1v4.5H23.9v6.1h5.3V50.6Z' })
            );
        };

        _this._getFourSquareIcon = function (_ref2) {
            var dataHook = _ref2.dataHook,
                style = _ref2.style;

            return _react2.default.createElement(
                'g',
                { 'data-hook': dataHook },
                _react2.default.createElement('path', { transform: 'translate(-1, -1)', className: style, d: 'M43.5,17.4H24.9a3.1,3.1,0,0,0-3.3,3.1V49.6a2,2,0,0,0,1.1,2,2.1,2.1,0,0,0,2.2-.5L34,40.9l.4-.2h5.6c2.4,0,2.8-1.7,3-2.7s2.5-12.6,3.3-16.3-.1-4.4-2.9-4.4Zm-.4,20.7c.2-.8,2.5-12.6,3.3-16.3L43.1,38.1Zm-.7-15.7-.8,4a1.1,1.1,0,0,1-1,.8H33.4a1.5,1.5,0,0,0-1.5,1.4v.9a1.5,1.5,0,0,0,1.5,1.5h6.2a1,1,0,0,1,.9,1.1l-.8,4.1a1,1,0,0,1-1,.8h-5c-1,0-1.3,0-1.9.8L25.6,45h-.1V22.3a1.2,1.2,0,0,1,1.1-1.1H41.5a1,1,0,0,1,.9,1.2Z' })
            );
        };

        _this._getTwitterIcon = function (_ref3) {
            var dataHook = _ref3.dataHook,
                style = _ref3.style;

            return _react2.default.createElement(
                'g',
                { 'data-hook': dataHook },
                _react2.default.createElement('path', { transform: 'translate(-1, -1)', className: style, d: 'M51,24.1a14.2,14.2,0,0,1-4.1,1.1A7.1,7.1,0,0,0,50,21.3,14.1,14.1,0,0,1,45.5,23a7.1,7.1,0,0,0-12.1,6.5,20.1,20.1,0,0,1-14.6-7.4,7.1,7.1,0,0,0,2.2,9.4,7.1,7.1,0,0,1-3.2-.9h0a7.1,7.1,0,0,0,5.7,6.9l-1.9.2H20.4A7.1,7.1,0,0,0,27,42.7a14.2,14.2,0,0,1-8.8,3H16.5a20,20,0,0,0,10.8,3.2c13,0,20.1-10.8,20.1-20.1,0-.3,0-.6,0-.9A14.3,14.3,0,0,0,51,24.1' })
            );
        };

        _this._getYelpIcon = function (_ref4) {
            var dataHook = _ref4.dataHook,
                style = _ref4.style;

            return _react2.default.createElement(
                'g',
                { transform: 'translate(-1, -1)', 'data-hook': dataHook },
                _react2.default.createElement('path', { className: style, d: 'M21.3,32.8c-.6.9-.8,3.9-.6,5.9a4.6,4.6,0,0,0,.4,1.5,1.3,1.3,0,0,0,1.1.7c.3,0,.5,0,5.9-1.8l2.4-.8a1.5,1.5,0,0,0,1-1.4,1.6,1.6,0,0,0-1-1.6l-1.7-.7c-5.8-2.4-6.1-2.5-6.4-2.5A1.3,1.3,0,0,0,21.3,32.8Z' }),
                _react2.default.createElement('path', { className: style, d: 'M34.4,50.8c.1-.3.1-.5.1-6.2,0,0,0-2.5,0-2.5a1.5,1.5,0,0,0-1-1.4,1.6,1.6,0,0,0-1.8.4l-1.2,1.4c-4.1,4.8-4.3,5-4.4,5.3a1.1,1.1,0,0,0-.1.5,1.4,1.4,0,0,0,.3.7c.9,1.1,5.5,2.8,7,2.6A1.3,1.3,0,0,0,34.4,50.8Z' }),
                _react2.default.createElement('path', { className: style, d: 'M43.6,48.8c1.4-.5,4.4-4.4,4.6-5.8a1.3,1.3,0,0,0-.4-1.2l-5.8-2-2.4-.8a1.5,1.5,0,0,0-1.7.5,1.6,1.6,0,0,0-.2,1.9l1,1.6c3.2,5.2,3.5,5.6,3.7,5.8a1.2,1.2,0,0,0,1.3.1Z' }),
                _react2.default.createElement('path', { className: style, d: 'M40.8,35.3c6.2-1.5,6.4-1.6,6.7-1.7a1.3,1.3,0,0,0,.5-1.2.3.3,0,0,0,0-.1c-.2-1.5-2.8-5.5-4.1-6.1a1.3,1.3,0,0,0-1.3.1c-.2.2-.4.4-3.7,4.9l-1.5,2.1a1.5,1.5,0,0,0,0,1.8,1.6,1.6,0,0,0,1.7.7h0Z' }),
                _react2.default.createElement('path', { className: style, d: 'M34.6,30.2h0c-.1-2.4-.8-13.3-.9-13.8a1.3,1.3,0,0,0-1-.9c-1.6-.4-7.6,1.3-8.7,2.4a1.3,1.3,0,0,0-.4,1.2l7.6,12.1c1.1,1.8,2,1.5,2.3,1.4S34.7,32.3,34.6,30.2Z' })
            );
        };

        _this._getInstagramIcon = function (_ref5) {
            var dataHook = _ref5.dataHook,
                style = _ref5.style;

            return _react2.default.createElement(
                'g',
                { transform: 'translate(-1, -1)', 'data-hook': dataHook },
                _react2.default.createElement('path', { className: style, d: 'M33.5,15.3H26a13.4,13.4,0,0,0-4.4.8,9.3,9.3,0,0,0-5.3,5.3,13.4,13.4,0,0,0-.8,4.4c-.1,1.9-.1,2.6-.1,7.5s0,5.6.1,7.5a13.4,13.4,0,0,0,.8,4.4,9.3,9.3,0,0,0,5.3,5.3,13.4,13.4,0,0,0,4.4.8H41a13.4,13.4,0,0,0,4.4-.8,9.3,9.3,0,0,0,5.3-5.3,13.4,13.4,0,0,0,.8-4.4c.1-1.9.1-2.6.1-7.5s0-5.6-.1-7.5a13.4,13.4,0,0,0-.8-4.4,9.3,9.3,0,0,0-5.3-5.3,13.4,13.4,0,0,0-4.4-.8Zm0,3.3h7.4a10.1,10.1,0,0,1,3.4.6,6,6,0,0,1,3.5,3.5,10.1,10.1,0,0,1,.6,3.4c.1,1.9.1,2.5.1,7.4s0,5.4-.1,7.4a10.1,10.1,0,0,1-.6,3.4,6,6,0,0,1-3.5,3.5,10.1,10.1,0,0,1-3.4.6H26.1a10.1,10.1,0,0,1-3.4-.6,6,6,0,0,1-3.5-3.5,10.1,10.1,0,0,1-.6-3.4c-.1-1.9-.1-2.5-.1-7.4s0-5.4.1-7.4a10.1,10.1,0,0,1,.6-3.4,6,6,0,0,1,3.5-3.5,10.1,10.1,0,0,1,3.4-.6h7.4' }),
                _react2.default.createElement('path', { className: style, d: 'M33.5,39.6a6.1,6.1,0,1,1,6.1-6.1,6.1,6.1,0,0,1-6.1,6.1Zm0-15.4a9.4,9.4,0,1,0,9.4,9.4,9.4,9.4,0,0,0-9.4-9.4Z' }),
                _react2.default.createElement('path', { className: style, d: 'M45.4,23.8a2.2,2.2,0,1,1-2.2-2.2,2.2,2.2,0,0,1,2.2,2.2Z' })
            );
        };

        _this._getTripAdvisorIcon = function (_ref6) {
            var dataHook = _ref6.dataHook,
                style = _ref6.style;

            return _react2.default.createElement(
                'g',
                { 'data-hook': dataHook },
                _react2.default.createElement('circle', { className: style, cx: '23.4', cy: '34.4', r: '1.6' }),
                _react2.default.createElement('circle', { className: style, cx: '43.5', cy: '34.4', r: '1.6' }),
                _react2.default.createElement('path', { className: style, d: 'M43.5,29.6a4.9,4.9,0,1,0,4.9,4.9A4.9,4.9,0,0,0,43.5,29.6Zm0,8.2a3.4,3.4,0,1,1,3.4-3.4A3.4,3.4,0,0,1,43.5,37.8Z' }),
                _react2.default.createElement('path', { className: style, d: 'M53.6,24.6H46.9a24,24,0,0,0-13.4-3.7,25.2,25.2,0,0,0-13.7,3.7H13.4a9.3,9.3,0,0,1,2,4A10,10,0,0,0,31.3,40.8a25.2,25.2,0,0,1,2.2,3.1s1.4-2.1,2.2-3.1A10,10,0,0,0,51.6,28.6,9.3,9.3,0,0,1,53.6,24.6ZM23.5,42.5a8,8,0,1,1,8-8A8,8,0,0,1,23.5,42.5Zm0-18a25.6,25.6,0,0,1,10-1.9,24,24,0,0,1,9.7,1.9,10,10,0,0,0-9.7,10A10,10,0,0,0,23.5,24.5Zm20,18a8,8,0,1,1,8-8A8,8,0,0,1,43.5,42.5Z' }),
                _react2.default.createElement('path', { className: style, d: 'M23.4,29.6a4.9,4.9,0,1,0,4.9,4.9A4.9,4.9,0,0,0,23.4,29.6Zm0,8.2a3.4,3.4,0,1,1,3.4-3.4A3.4,3.4,0,0,1,23.4,37.8Z' })
            );
        };

        _this.defaultDimension = 150;
        _this.defaultTheme = {
            type: SOCIAL_ICON_TYPES.BRANDED,
            inverse: false,
            borderRadius: 'circle',
            hasBackground: true,
            hasBorder: false
        };
        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(SvgSocialIcon, [{
        key: 'render',
        value: function render() {
            var dimension = Math.max(this.props.dimension || this.defaultDimension, MIN_DIMENSION);
            var theme = this._getTheme();
            var icon = this._getIcon(dimension);

            var className = this._getClassName(theme, dimension);

            return _react2.default.createElement(
                'svg',
                { version: '1.1', width: dimension, height: dimension, className: className },
                icon,
                this._getRing(dimension),
                this._getSquareOutline(dimension)
            );
        }
    }]);
    return SvgSocialIcon;
}(_react2.default.Component), _class.propTypes = {
    type: _propTypes2.default.string.isRequired,
    dimension: _propTypes2.default.number,
    theme: _propTypes2.default.object,
    className: _propTypes2.default.string,
    hoverState: _propTypes2.default.bool
}, _temp);


SvgSocialIcon.THEME_TYPES = SOCIAL_ICON_TYPES;
SvgSocialIcon.RADIUS_TYPES = SOCIAL_ICON_BORDER_RADIUS_TYPES;

exports.default = SvgSocialIcon;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-components-css-modules/dist/svg/SocialIcon/SvgSocialIcon.js
// module id = 306
// module chunks = 0